define('uikit/elements/checkbox',['require','exports','module','underscore','marionette','../channel','../mixins/component.mixin','../templates','../extra/key.codes','semantic/modules/checkbox'],function(require, exports, module){
  var _              = require('underscore');
  var Mn             = require('marionette');
  var channel        = require('../channel');
  var ComponentMixin = require('../mixins/component.mixin');
  var Templates      = require('../templates');
  var KeyCodes       = require('../extra/key.codes');
  require('semantic/modules/checkbox');

  var CheckboxView = Mn.ItemView.extend(ComponentMixin).extend({

    className: 'ui checkbox',

    template: Templates.UIKit['checkbox'],

    triggers: {
      'focus @ui.input': {
        preventDefault: false,
        event: 'focus'
      }
    },

    events: {
      'keydown @ui.input': function(ev) {
        // Refocus checkbox after keyboard toggle
        if (!ev.ctrlKey && (ev.keyCode == KeyCodes.ENTER_KEY || ev.keyCode == KeyCodes.SPACE_KEY)) {
          this.ui.input.focus();
        }
      },
      'change @ui.input': function(ev) {
        var self = this;
        _.defer(function() {
          self.syncValueWithDom();
        });
      }
    },

    ui: {
      'input': 'input[type="radio"],input[type="checkbox"]'
    },

    options: {
      checkboxId           : '',
      visible              : true,
      radio                : false,
      readonly             : false,
      disabled             : false,
      disableCheckboxModule: false,
      fitted               : false,
      toggle               : false,
      polar                : false,
      slider               : false,
      uncheckable          : false,
      useLabel             : false,
      text                 : '',
      input                : null,
      value                : false,
      useViewIdAsId        : false
    },

    forceUpdate: {
      checkboxId: true,
      radio: true,
      disableCheckboxModule: true,
      slider: true,
      uncheckable: true,
      input: true,
      value: true,
      useLabel: true
    },

    // default bindings if a model
    // is provided
    bindings: {
      // text  : 'text',
      // value : 'value'
    },

    onFirstRender: function() {
      var self = this;

      if (this.getOption('useViewIdAsId')) {
        this.checkboxId = this.cid;
      }

      this
          .on('change:text', function() {
            if (!this.input && this.useLabel) {
              this.$('label').text(this.text);
            }
          }, this)
          .on('change:value', function(self, value, previous, options) {
            if (this.readonly || options.internal === this) { return; }
            this.applyCheckValue();
          }, this);
          
      _.defer(function() {
        self.applyCheckValue();
      })
    },

    applyCheckValue: function() {
      if (this.value) {
        this.$el.checkbox('check');
      } else {
        this.$el.checkbox('uncheck');
      }
    },

    onFocus: function() {
      var self = this;
      // if we have an input view and we were not previously focused on it
      // then focus on that input
      if (this.radio && this.input && this.input.ui.input.get(0) !== this._previousFocus) {
        _.defer(function() {
          if (self.ui.input.get(0) == document.activeElement) {
            self.input.focus();
          }
        });
      }
      this._previousFocus = null;
    },

    onInputFocus: function() {
      this._previousFocus = document.activeElement;
      if (this.radio && !this.readonly) {
        this.value = true;
      }
    },

    updateAttributes: function() {
      var self = this;

      this
          .addClass('fitted', this.getBoolOption('fitted'))
          .addClass('toggle', this.getBoolOption('toggle'))
          .addClass('polar', this.getBoolOption('polar')) // Only applies to toggles
          .addClass('slider', this.getBoolOption('slider'))
          .addClass('radio', this.getBoolOption('radio'))
          .addClass('read-only', this.getBoolOption('readonly'))
          .addClass('disabled', this.getBoolOption('disabled'))

      this.$el.prop('disabled', this.getBoolOption('disabled'));

      if (!this.disableCheckboxModule) {
        this.$el
            .checkbox({
              fireOnInit: false,
              onChange: function() {
                self.syncValueWithDom();
              }
            });
      } else {
        this.$el.checkbox('destroy');
      }
    },

    syncValueWithDom: function() {
      var isChecked = this.$el.checkbox('is checked');
      if (this.getBoolOption('readonly')) {
        if (isChecked !== this.value) {
          this.applyCheckValue();
        }
      } else if (this.value !== isChecked) {
        this._setOption('value', isChecked, { internal: this });
      }
    }

  });

  channel.reply('checkbox', function() {
    return CheckboxView;
  });

  module.exports = CheckboxView;
});
